import { api, timeAgo, csrfToken } from "../editor/store"

export async function buildHistoryPane({ snapshotsUrl, onRestored }) {
  const snapshots = await api(snapshotsUrl)

  const pane = document.createElement("section")
  pane.className = "pane"
  pane.tabIndex = -1
  pane.dataset.workspaceTarget = "pane"
  pane.dataset.history = "true"

  const header = document.createElement("header")
  header.className = "px-5 pt-5 pb-3 border-b border-nord3/40"
  const title = document.createElement("h2")
  title.className = "text-xl font-bold text-nord6"
  title.textContent = "History"
  header.appendChild(title)
  const subtitle = document.createElement("p")
  subtitle.className = "mt-0.5 text-xs text-nord4/50"
  subtitle.textContent = snapshots.length
    ? `${snapshots.length} earlier ${snapshots.length === 1 ? "version" : "versions"}, newest first`
    : ""
  header.appendChild(subtitle)
  pane.appendChild(header)

  if (!snapshots.length) {
    const empty = document.createElement("p")
    empty.className = "px-5 py-6 text-sm text-nord4/50 italic"
    empty.textContent = "No history yet — it begins with your first change."
    pane.appendChild(empty)
    return pane
  }

  const list = document.createElement("ol")
  list.className = "px-3 py-3 space-y-0.5 max-h-56 overflow-y-auto shrink-0"
  pane.appendChild(list)

  const preview = document.createElement("div")
  preview.className = "hidden flex-1 min-h-0 flex flex-col border-t border-nord3/40"
  pane.appendChild(preview)

  snapshots.forEach((snapshot) => {
    const item = document.createElement("li")
    const row = document.createElement("button")
    row.type = "button"
    row.className = "inspector-cast w-full"

    const when = document.createElement("span")
    when.className = "truncate text-sm text-nord4"
    when.textContent = timeAgo(new Date(snapshot.created_at))
    row.appendChild(when)

    const words = document.createElement("span")
    words.className = "text-xs text-nord4/50 tabular-nums"
    words.textContent = `${snapshot.words.toLocaleString()} words`
    row.appendChild(words)

    row.addEventListener("click", () => showPreview(snapshot, row))
    item.appendChild(row)
    list.appendChild(item)
  })

  async function showPreview(snapshot, row) {
    list.querySelectorAll(".is-highlighted").forEach((el) => el.classList.remove("is-highlighted"))
    row.classList.add("is-highlighted")
    const detail = await api(`${snapshotsUrl}/${snapshot.id}`)

    preview.replaceChildren()
    preview.classList.remove("hidden")

    const bar = document.createElement("div")
    bar.className = "flex items-center justify-between px-5 py-2.5 border-b border-nord3/40"
    const label = document.createElement("span")
    label.className = "text-[11px] uppercase tracking-widest text-nord4/50"
    label.textContent = timeAgo(new Date(detail.created_at))
    bar.appendChild(label)

    const restore = document.createElement("button")
    restore.type = "button"
    restore.className = "flow-tab is-active"
    restore.textContent = "Restore this version"
    restore.addEventListener("click", async () => {
      const response = await fetch(`${snapshotsUrl}/${snapshot.id}/restore`, {
        method: "POST",
        headers: { "X-CSRF-Token": csrfToken(), Accept: "application/json" }
      })
      if (response.ok) onRestored((await response.json()).url)
    })
    bar.appendChild(restore)
    preview.appendChild(bar)

    const body = document.createElement("pre")
    body.className = "history-preview flex-1 overflow-y-auto px-5 py-4"
    body.textContent = detail.body
    preview.appendChild(body)
  }

  return pane
}
